import { text } from "@quickpoint.me/shared";
import { useRecoilValue } from "recoil";
import { HostId } from "../../state/atoms";
import { IsInPortrait } from "../../state/selectors";
import { openMobilePreview } from "../preview/MobilePreviewButton";
import { TopBarControl } from "../StyledControl";

function MobilePreview() {
  const hostId = useRecoilValue(HostId);
  const isInPortrait = useRecoilValue(IsInPortrait);

  const handleClick = () => {
    openMobilePreview(hostId);
  };

  return (
    <TopBarControl
      $isInPortrait={isInPortrait}
      onClick={handleClick}
      className="top-bar-control preview"
      data-testid="mobile-preview-control"
      aria-label={text.controls.preview}
    >
      {text.controls.preview}
    </TopBarControl>
  );
}

export default MobilePreview;
